export default "__VITE_ASSET__fiw0Tuci__"